
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/environments",
      function () {
        return require("private-next-pages/workspace-management/environments.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/environments"])
      });
    }
  